import Values from "../value/Values";
import BigNumSave from "./BigNumSave";

export default class ValuesSave {
    constructor() {        
    }

    /**
     * @param {Values} values
     * @returns {Object}
     */
    static generateSave(values) {
        const saveState = {};

        saveState.mineDamageMultiplier = BigNumSave.save(values.minedDamageBonusMultiplier.getValue());
        saveState.mineOreBonus = BigNumSave.save(values.minedOreBonus.getValue());

        // Do not save the base values. These are tied to pick upgrades and are saved/loaded via the PickUpgradeCollectionSave.
        // saveState.baseAddValue = BigNumSave.save(values.baseAdditiveBonusPerTurn.getValue());
        // saveState.baseMulValue = BigNumSave.save(values.baseMultiplicativeBonusValue.getValue());

        return saveState;
    }

    /**
     * @param {Values} values
     * @param {Object} saveState 
     */
    static loadSave(values, saveState) {
        if (!saveState) {
            return;
        }

        BigNumSave.load(saveState.mineDamageMultiplier, values.minedDamageBonusMultiplier.getValue());
        BigNumSave.load(saveState.mineOreBonus, values.minedOreBonus.getValue());

        // Do not save the base values. These are tied to pick upgrades and are saved/loaded via the PickUpgradeCollectionSave.
        // BigNumSave.load(saveState.baseAddValue, values.baseAdditiveBonusPerTurn.getValue());
        // BigNumSave.load(saveState.baseMulValue, values.baseMultiplicativeBonusValue.getValue());
    }

}